import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'arrowIconAssessment',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#387DFF",
  },
  width: {
    type: Number as PropType<number | string>,
    default: 12,
  },
  height: {
    type: Number as PropType<number | string>,
    default: 9,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none"
  }, [
    _createElementVNode("path", {
      d: "M11.8741 2.10715L6.38429 8.33065C6.33485 8.3829 6.27527 8.42453 6.2092 8.45297C6.14312 8.48142 6.07194 8.49609 6 8.49609C5.92806 8.49609 5.85688 8.48142 5.7908 8.45297C5.72473 8.42453 5.66515 8.3829 5.61571 8.33065L0.125859 2.10715C0.081969 2.05772 0.0483386 2.00005 0.02692 1.93751C0.00550146 1.87497 -0.00327902 1.80879 0.00108975 1.74283C0.0065009 1.67633 0.0251891 1.6116 0.056049 1.55245C0.086909 1.4933 0.129313 1.44094 0.180757 1.39846L1.10405 0.624894C1.15449 0.581267 1.21315 0.548191 1.27658 0.527618C1.34002 0.507046 1.40693 0.499394 1.47337 0.505115C1.53949 0.509899 1.604 0.52781 1.66313 0.557801C1.72225 0.587792 1.77481 0.629263 1.81773 0.679792L5.91516 5.39607C5.94039 5.42106 5.97447 5.43508 6.00998 5.43508C6.04549 5.43508 6.07957 5.42106 6.10481 5.39607L10.1823 0.679792C10.2629 0.583426 10.377 0.521046 10.5017 0.505115C10.5678 0.498714 10.6345 0.50557 10.6979 0.525281C10.7613 0.544992 10.8202 0.57716 10.871 0.619902L11.8192 1.39846C11.8707 1.44094 11.9131 1.4933 11.9439 1.55245C11.9748 1.6116 11.9935 1.67633 11.9989 1.74283C12.0033 1.80879 11.9945 1.87497 11.9731 1.93751C11.9517 2.00005 11.918 2.05771 11.8741 2.10715Z",
      fill: __props.color
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})